import { FC, useCallback } from 'react';

import { audioManager } from 'lib/audio/audio-manager';

import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';
import { useUIStore } from 'shared/store/uiStore';

import soundOff from 'assets/png/sound-off.png?format=webp;avif&as=picture';
import soundOn from 'assets/png/sound-on.png?format=webp;avif&as=picture';

export const SoundTogglePanel: FC = () => {
  const isAudioMuted = useUIStore((s) => s.sound.isAudioMuted);
  const toggleAudioMuted = useUIStore((s) => s.toggleAudioMuted);

  const toggle = useCallback(() => {
    audioManager.toggleMute();
    toggleAudioMuted();
  }, [toggleAudioMuted]);

  return (
    <div className="z-50 flex">
      <button
        onClick={toggle}
        className="flex items-center border-none bg-transparent text-xl"
        title="Toggle Sound"
      >
        <OptimizedImage
          imageData={isAudioMuted ? soundOff : soundOn}
          alt={isAudioMuted ? 'sound off' : 'sound on'}
          className="h-[2.75rem] w-[2.75rem]"
        />
      </button>
    </div>
  );
};
